import moment from "moment";

/** "Oct 5 – Oct 16, 2026", or with both years when the dates fall in different years. */
export function formatDateRange(startDate, endDate) {
  if (!startDate && !endDate) return "No dates";
  if (!startDate || !endDate) return moment(startDate || endDate).format("MMM D, YYYY");

  const start = moment(startDate);
  const end = moment(endDate);
  if (start.year() === end.year()) {
    return `${start.format("MMM D")} – ${end.format("MMM D, YYYY")}`;
  }
  return `${start.format("MMM D, YYYY")} – ${end.format("MMM D, YYYY")}`;
}

/** Hours with at most one decimal and a unit, e.g. "32 h" or "7.5 h". */
export function formatHours(value) {
  const hours = Number(value) || 0;
  return `${Number.isInteger(hours) ? hours : hours.toFixed(1)} h`;
}

/** "3 tasks" / "1 task". */
export function pluralize(count, singular, plural = `${singular}s`) {
  return `${count} ${count === 1 ? singular : plural}`;
}

/** Whether the current user holds a permission, read from the permissions stored at sign-in. */
export function hasPermission(permission) {
  try {
    return (localStorage.getItem("permissions") || "").includes(permission);
  } catch {
    return false;
  }
}
